// this is an autogenerated file from DesignSystem/TasksBoardsList/Boards/mutation-move-board.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_TasksBoardsList_Boards($board_order: jsonb!) {
  insert_user_preferences_one(
    object: { board_order: $board_order }
    on_conflict: {
      constraint: user_preferences_pkey
      update_columns: [board_order]
    }
  ) {
    user_id
    board_order
  }
}

`